'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagPgAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 4.91738e-06C9.33333 -4.63379e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V4.91738e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 4.91738e-06L28 0V20H0V4.91738e-06Z", fill: "#262626" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 4.91738e-06L28 0V20L0 4.91738e-06Z",
          fill: "#E8283F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66667 16.6667L5.72386 16.9428L6 16L5.72386 15.0572L6.66667 15.3333L7.60948 15.0572L7.33333 16L7.60948 16.9428L6.66667 16.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66667 8.66667L5.72386 8.94281L6 8L5.72386 7.05719L6.66667 7.33333L7.60948 7.05719L7.33333 8L7.60948 8.94281L6.66667 8.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.33333 12L2.39052 12.2761L2.66667 11.3333L2.39052 10.3905L3.33333 10.6667L4.27614 10.3905L4 11.3333L4.27614 12.2761L3.33333 12Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33333 11.3333L8.39052 11.6095L8.66667 10.6667L8.39052 9.72386L9.33333 10L10.2761 9.72386L10 10.6667L10.2761 11.6095L9.33333 11.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.8612 9.26557C18.7016 9.1698 18.5722 8.9442 18.5722 8.76371V7.53499C18.5722 7.35359 18.4417 7.25005 18.2442 7.31588L17.486 7.56861C17.3049 7.62899 17.0275 7.63444 16.83 7.56861L16.0718 7.31588C15.8907 7.25549 15.8705 7.13051 16.0328 7.03313L17.8118 5.96574C17.9714 5.86997 18.0573 5.66182 17.9915 5.46432L17.7388 4.70612C17.6784 4.52497 17.7599 4.42162 17.9574 4.48745L18.7156 4.74018C18.8968 4.80057 19.1197 4.7228 19.217 4.5605L20.2844 2.78151C20.3802 2.62189 20.5013 2.62301 20.5672 2.8205L20.8199 3.57871C20.8803 3.75986 20.8857 4.03722 20.8199 4.23471L20.5672 4.99292C20.5068 5.17407 20.6058 5.32092 20.7863 5.32092H22.015C22.1964 5.32092 22.4195 5.44765 22.5169 5.60994L23.5843 7.38893C23.68 7.54855 23.603 7.70888 23.4299 7.74349L21.7284 8.0838C21.5474 8.12 21.3697 8.304 21.3351 8.47708L20.9948 10.1786C20.9586 10.3596 20.8025 10.4303 20.6402 10.333L18.8612 9.26557Z",
          fill: "#FFD84E"
        }
      )
    ]
  }
);
const VpFlagPgAsset = forwardRef(FlagPgAsset);

export { VpFlagPgAsset as default };
